import React from 'react';
import './App.css';
import Routes from './routes/Routes';
// @ts-nocheck

import { useGetAuthUser } from './useGetAuthUser';
import { AppCircularProgress } from './components/common/loaders/AppCircularProgress';
import { AppAlerts } from './components';
import { AppPopup } from './components/appPopup';
import { Box } from '@mui/material';
import { appGetAnalytics } from './utils/analytics';
import { FilterProvider } from './services/mVPMapService/filterContext';
import { useAuthHelper } from './utils/functions/authentication';
import { useMsal } from '@azure/msal-react';

appGetAnalytics();

function App() {
  const { authUser, isLoading } = useGetAuthUser();
  const { instance } = useMsal();
  const { refreshToken } = useAuthHelper();
  console.log(instance, refreshToken);

  if (isLoading) {
    return <AppCircularProgress />;
  }

  return (
    <FilterProvider>
      <AppPopup />
      <AppAlerts />

      <Box>
        {' '}
        {/* Add padding to account for fixed header */}
        <Routes authUser={authUser!} />
      </Box>
    </FilterProvider>
  );
}

export default App;
